<template>
  <div class="solution-page-partner-container">
    <div class="partner-title">
      <span class="main-title wow fadeInUp">合作伙伴</span>
      <span class="sub-title wow fadeInUp"
        >为各行业合作伙伴提供完善的服务支持</span
      >
    </div>
    <div class="partner-card-container">
      <div class="partner-card wow fadeInLeft">
        <img src="@/assets/images/partner-mly.png" alt="" />
      </div>
      <div class="partner-card wow fadeInRight">
        <img src="@/assets/images/partner-renai.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.solution-page-partner-container {
  height: 340px;
  background: #ffffff;
  .partner-title {
    display: flex;
    flex-direction: column;
    margin-top: 80px;
    .main-title {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #222222;
      text-align: center;
    }
    .sub-title {
      margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #3d3d3d;
      line-height: 26px;
      text-align: center;
    }
  }
  .partner-card-container {
    display: flex;
    // width: 40%;
    width: 450px;
    margin: 50px auto 0;
    .partner-card {
      img {
        width: 220px;
      }
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solution/components/partner.vue